var _defs, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocusing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 506.92 675.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".focusing,.focusing2{fill:none;stroke:#245a8e;stroke-miterlimit:10;stroke-width:35.32px;}.focusing3{fill:blue;}.focusing4{fill:#e20613;}.focusing2{stroke-linecap:round;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "focusing3",
    cx: 176.56,
    cy: 67.4,
    r: 67.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "focusing4",
    cx: 325.16,
    cy: 67.4,
    r: 67.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "focusing",
    cx: 253.46,
    cy: 422.1,
    r: 235.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 197.66,
    y1: 297,
    x2: 253.46,
    y2: 431.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 47.26,
    y1: 422.1,
    x2: 17.66,
    y2: 422.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 489.16,
    y1: 422.1,
    x2: 459.56,
    y2: 422.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 249.46,
    y1: 215.9,
    x2: 249.46,
    y2: 186.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 249.46,
    y1: 657.9,
    x2: 249.46,
    y2: 628.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 395.06,
    y1: 275.9,
    x2: 415.96,
    y2: 255
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 84.46,
    y1: 586.5,
    x2: 103.56,
    y2: 567.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 394.66,
    y1: 567.9,
    x2: 415.56,
    y2: 588.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "focusing2",
    x1: 84.46,
    y1: 257.7,
    x2: 103.06,
    y2: 276.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "focusing2",
    d: "m197.16,295.3l-22,9.1c-.6.3-1.2,0-1.5-.5-.1-.2-.1-.4-.1-.6l3.1-23.6,3.1-23.6c.1-.6.6-1,1.2-1,.2,0,.4.1.6.2l18.9,14.5,18.9,14.5c.5.4.6,1,.2,1.5-.1.2-.3.3-.5.4l-21.9,9.1Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusing);
export default __webpack_public_path__ + "static/media/Focusing.875d1ae86a8f23577fb548798bb6cefa.svg";
export { ForwardRef as ReactComponent };